var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 4.09091V6.54545L10.5 3.27273L7 0V2.45455C3.1325 2.45455 0 5.38364 0 9C0 10.2845 0.4025 11.4791 1.085 12.4855L2.3625 11.2909C1.96875 10.6118 1.75 9.82636 1.75 9C1.75 6.29182 4.10375 4.09091 7 4.09091ZM12.915 5.51455L11.6375 6.70909C12.0225 7.39636 12.25 8.17364 12.25 9C12.25 11.7082 9.89625 13.9091 7 13.9091V11.4545L3.5 14.7273L7 18V15.5455C10.8675 15.5455 14 12.6164 14 9C14 7.71545 13.5975 6.52091 12.915 5.51455Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.b29008aba5c00f06d2e2ff89e83f7356.svg";
export { ForwardRef as ReactComponent };